var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteFloorplanTour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "white-floorplan-tour_svg__a",
    d: "M0 .074h5.013v.852H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-floorplan-tour_svg__c",
    d: "M0 .074h6.297v.852H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-floorplan-tour_svg__e",
    d: "M.074 0h.852v15.652H.074z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "white-floorplan-tour_svg__g",
    d: "M0 .074h15.653v.852H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.15 15.912h5.013H.15z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.15 15.338)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "white-floorplan-tour_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-floorplan-tour_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    mask: "url(#white-floorplan-tour_svg__b)",
    d: "M5.013.574H0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.395 15.912h6.297-6.297z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.395 15.338)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "white-floorplan-tour_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-floorplan-tour_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    mask: "url(#white-floorplan-tour_svg__d)",
    d: "M6.297.574H0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.5 16.152V.5v15.652z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.073 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "white-floorplan-tour_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-floorplan-tour_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    mask: "url(#white-floorplan-tour_svg__f)",
    d: "M.426 15.652V0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.36 16.152V7.969v8.183z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M13.36 16.152V7.969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.15.5h15.654H.15z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.15 .074)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "white-floorplan-tour_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#white-floorplan-tour_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    mask: "url(#white-floorplan-tour_svg__h)",
    d: "M0 .426h15.653"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.993 7.97h3.013-3.013z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M12.993 7.969h3.013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.683 8.325V.152v8.174z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M15.683.152v8.174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.772 7.686V.5v7.186z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M8.772.5v7.187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.965 15.912v-3.85 3.85z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M8.966 12.061v3.851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.757 6.118h4.208-4.208z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M8.966 6.118H4.757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 6.118h2.712H.5z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M3.212 6.118H.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.36 10.695h3.938H.36z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M4.297 10.695H.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.165 15.912v-3.85 3.85z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M4.165 12.061v3.851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.508 10.695h4.863-4.863z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.704,
    d: "M13.371 10.695H8.509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.705 13.055l.982-.564a.23.23 0 00-.03-.414l-4.381-1.737a.234.234 0 00-.25.051.228.228 0 00-.05.248l1.747 4.356a.233.233 0 00.416.031l.567-.978 1.377 1.37a.227.227 0 00.327 0l.672-.669a.228.228 0 000-.325l-1.377-1.369z",
    fill: "#FFF"
  }))));
}

export default SvgWhiteFloorplanTour;